/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_Setting_ValueInputs */

const en_fw_node_setting_value = /** @type {(inputs: Fw_Node_Setting_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meiji-era Japan`)
};

const zh_fw_node_setting_value = /** @type {(inputs: Fw_Node_Setting_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明治时代的日本`)
};

/**
* | output |
* | --- |
* | "Meiji-era Japan" |
*
* @param {Fw_Node_Setting_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_setting_value = /** @type {((inputs?: Fw_Node_Setting_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_Setting_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_setting_value(inputs)
	return zh_fw_node_setting_value(inputs)
});
export { fw_node_setting_value as "fw.node.setting_value" }